import { useAppSelector } from '../app/hooks';
import { selectAuthUser } from '../app/authSlice';
import { selectConfig } from '../app/configSlice';
import { useGetUserSettingsQuery } from '../api/userApi';
import { LoginType } from '../api-types/models/LoginDto';
import { getUserGroups, isBrunchSession } from '../utils/user';

export function useUserSettings() {
    const config = useAppSelector(selectConfig);
    const user = useAppSelector(selectAuthUser);
    const loginType = localStorage.getItem('login');
    const userGroups = getUserGroups(user);

    const shouldFetch =
        !!config &&
        !isBrunchSession(loginType, userGroups) &&
        (loginType === LoginType.SPORTRADAR ||
            userGroups.includes(LoginType.TENANTS) ||
            !!user);

    return useGetUserSettingsQuery(undefined, { skip: !shouldFetch });
}

export default useUserSettings;
